/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.geofences

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.geofences.GeofencesApi
import features.geofences.models.GeofencesModel
import features.geofences.serializeGeofencesState



/**
 * Get the list of geofences of a business [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("GeofencesApi")
class GeofencesApiJs {

    /**
     * Get the list of geofences of a business
     */
    fun getBusinessGeofences(
        overrideHeaders: String?, 
        pageNumber: Int,
        perPage: Int
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = GeofencesApi().getBusinessGeofences(
            overrideHeaders = decodedOverrideHeaders,
                        pageNumber = pageNumber,
            perPage = perPage
        ).toJsonResult<GeofencesModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeGeofencesState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        GeofencesApi().geofencesState.serializeGeofencesState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
